/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
export var projectStatusList = [{
  value: -1,
  name: '全部',
  color: '#fa5d3a'
}, {
  value: 0,
  name: '未审批',
  color: '#e49100'
}, {
  value: 1,
  name: '进行中',
  color: '#39c19e'
}, {
  value: 2,
  name: '已完成',
  color: '#6CAFF5'
}];
export var approvalStatusList = [{
  value: 0,
  result: 1,
  name: '待审批',
  color: '#e49100'
}, {
  value: 1,
  result: 2,
  name: '审批通过',
  color: '#6CAFF5'
}, {
  value: 2,
  result: 2,
  name: '审批拒绝',
  color: '#ef0707'
}];
export var approvalStateList = [{
  value: 1,
  name: '审批中'
}, {
  value: 2,
  name: '审批完成'
}];
var map = projectStatusList.reduce(function (p, c) {
  p[c.value] = c.name;
  return p;
}, {});
export var projectStatusMap = map;
export var projectStatusMapFunc = function projectStatusMapFunc(state) {
  return projectStatusList.find(function (v) {
    return v.value === state;
  }) || {
    color: '#fa5d3a'
  };
};
export var approvalStatusListFunc = function approvalStatusListFunc(result) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (+state === 1) {
    result = 0;
  }

  return approvalStatusList.find(function (v) {
    return v.value === +result;
  }) || {
    color: '#fa5d3a'
  };
};